import React from "react";
import PropTypes from "prop-types";

// styles
import colors from "core/colors";
import { OffsetIconStyled } from "./styles";

// Components
import ToggleButton from "./ToggleButton";
import ClockSolid from "core/ReusableIcons/ClockSolid";
import ClockOutline from "core/ReusableIcons/ClockOutline";

export const Clock = ({
    isDisabled = false,
    isActivated = false,
    onToggle,
    moderationIconKey,
    testId
}) => {
    const ClockIcon = isActivated ? ClockSolid : ClockOutline;
    const fillColor = isDisabled
        ? colors.secondary.dolphin
        : colors.accent.lightMode.persian;

    return (
        <ToggleButton
            onToggle={onToggle}
            isActivated={isActivated}
            isDisabled={isDisabled}
            moderationIconKey={moderationIconKey}
            testId={testId}
            title="Save for later"
        >
            <OffsetIconStyled verticalOffset="1px">
                <ClockIcon
                    size={{ width: 22, height: 22 }}
                    fillColor={fillColor}
                />
            </OffsetIconStyled>
        </ToggleButton>
    );
};

// prop-types
Clock.propTypes = {
    moderationIconKey: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
    isActivated: PropTypes.bool,
    isDisabled: PropTypes.bool
};
